/**
 * Registers a callback that will be invoked when a notification is received via SignalR.
 *
 * The callback is stored in the global `window.signalRNotificationsCallbacks` registry
 * and will be called with:
 * - the received `Notification` instance
 *
 * @param {string} callbackId - Unique identifier for the callback (used as the registry key).
 * @param {Function} callback - Function to invoke when a notification is received.
 * @param {Object} callback.notification - Parsed notification object.
 * @param {Function} callback.downloadLink - Helper function to trigger notification download.
 *
 * @returns {void}
 */

export function setNotificationsCallback(callbackId, callback) {
  window.signalRNotificationsCallbacks[callbackId] = callback;
}